import type { Platform } from './keybindingTypes';

export type PlatformEnvironment = {
  readonly preloadPlatform?: string;
  readonly userAgentDataPlatform?: string;
  readonly navigatorPlatform?: string;
};

function normalizePlatform(value: string | undefined): Platform | null {
  if (!value) return null;
  const normalized = value.toLowerCase();
  if (normalized === 'darwin' || normalized.includes('mac')) return 'mac';
  if (normalized === 'win32' || normalized.includes('win')) return 'windows';
  if (normalized === 'linux' || normalized.includes('linux')) return 'linux';
  return null;
}

function browserEnvironment(): PlatformEnvironment {
  const browserWindow = globalThis as typeof globalThis & {
    electronAPI?: { windowChrome?: { platform?: string } };
    navigator?: Navigator & { userAgentData?: { platform?: string } };
  };
  return {
    preloadPlatform: browserWindow.electronAPI?.windowChrome?.platform,
    userAgentDataPlatform: browserWindow.navigator?.userAgentData?.platform,
    navigatorPlatform: browserWindow.navigator?.platform,
  };
}

export function platform(environment: PlatformEnvironment = browserEnvironment()): Platform {
  return normalizePlatform(environment.preloadPlatform)
    ?? normalizePlatform(environment.userAgentDataPlatform)
    ?? normalizePlatform(environment.navigatorPlatform)
    ?? 'linux';
}

export function isMac(environment?: PlatformEnvironment): boolean {
  return platform(environment) === 'mac';
}
